module.exports = __webpack_public_path__ + "img/MULTI_ROLE_A1014.c187d882.png";